var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"RMPE-Layout RMPE-Layout-ImageLeft"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column RMPE-Layout-BackgroundImage"},[_c('img',{staticClass:"RMPE-Layout-Image",attrs:{"src":_vm.image,"alt":""}})]),_c('div',{staticClass:"column RMPE-Layout-Field"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }